import { action } from 'typesafe-actions';

import { Client } from './types';

export function clientSuccess({ client }: { client: Client }) {
  return action('@client/CLIENT_SUCCESS', { client });
}
